import React, { useEffect, useState } from 'react';
import { getUsers, createUser, updateUser, deleteUser, getAliases, createAlias, deleteAlias } from '../../api';

function genCode() {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return Array.from({length:4}, ()=>chars[Math.floor(Math.random()*26)]).join('');
}

function genPass() {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  return Array.from({length:8}, ()=>chars[Math.floor(Math.random()*chars.length)]).join('');
}

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [form, setForm] = useState({ code:'', name:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [aliases, setAliases] = useState([]);
  const [newAlias, setNewAlias] = useState('');
  const [passModal, setPassModal] = useState(null); // {id, code, name}
  const [newPass, setNewPass] = useState('');
  const [passLoading, setPassLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const load = () => getUsers({ role:'customer' }).then(setCustomers).catch(console.error);
  useEffect(() => { load(); }, []);

  const handleGenerate = () => {
    setForm(f => ({ ...f, code: genCode(), password: genPass() }));
  };

  const handleAdd = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      await createUser({ ...form, role:'customer', code: form.code.toUpperCase() });
      setForm({ code:'', name:'', password:'' }); load();
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this customer?')) return;
    await deleteUser(id);
    if (selected?.id === id) setSelected(null);
    load();
  };

  const openCustomer = async (c) => {
    setSelected(c); setNewAlias('');
    getAliases({ customer_id: c.id }).then(setAliases);
  };

  const handleAddAlias = async (e) => {
    e.preventDefault();
    if (!newAlias.trim() || !selected) return;
    await createAlias({ name_on_label: newAlias.trim(), customer_id: selected.id });
    setNewAlias('');
    getAliases({ customer_id: selected.id }).then(setAliases);
  };

  const handleDeleteAlias = async (id) => {
    await deleteAlias(id);
    getAliases({ customer_id: selected.id }).then(setAliases);
  };

  const handleSetPass = async () => {
    if (!newPass.trim() || !passModal) return;
    setPassLoading(true);
    try {
      await updateUser(passModal.id, { password: newPass.trim() });
      setPassModal(null); setNewPass('');
    } catch(err) { alert(err.message); }
    finally { setPassLoading(false); }
  };

  return (
    <div>
      <style>{`
        .ci:focus { outline:none; border-color:var(--accent)!important; box-shadow:0 0 0 3px var(--accent-bg)!important; }
        .add-btn:hover:not(:disabled) { background:var(--bg-elevated)!important; border-color:var(--accent)!important; }
        .gen-btn:hover { background:rgba(15,23,42,0.10)!important; }
        .cust-row { border-bottom:1px solid rgba(15,23,42,0.05); transition:background 0.15s; cursor:pointer; }
        .cust-row:hover td { background:rgba(15,23,42,0.03); }
        .cust-row.active td { background:rgba(22,163,74,0.06); }
        .del-btn { background:transparent; border:1px solid rgba(220,38,38,0.20); color:rgba(220,38,38,0.40); border-radius:5px; padding:4px 10px; font-size:11px; cursor:pointer; transition:all 0.18s; }
        .del-btn:hover { background:rgba(220,38,38,0.10); color:#ff5252; }
        .pass-btn { background:rgba(15,23,42,0.05); border:1px solid rgba(15,23,42,0.10); color:var(--text-secondary); border-radius:5px; padding:4px 10px; font-size:11px; cursor:pointer; transition:all 0.18s; }
        .pass-btn:hover { background:var(--accent-bg); color:var(--accent); border-color:rgba(22,163,74,0.30); }
        .alias-tag { display:inline-flex; align-items:center; gap:6px; background:rgba(15,23,42,0.05); border:1px solid rgba(15,23,42,0.10); border-radius:6px; padding:5px 10px; font-size:12px; color:var(--text-secondary); margin:3px; }
        .alias-del { background:none; border:none; color:rgba(220,38,38,0.40); cursor:pointer; font-size:14px; padding:0; line-height:1; }
        .alias-del:hover { color:#ff5252; }
        .modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.7); display:flex; align-items:center; justify-content:center; z-index:100; }
      `}</style>

      <div style={s.topbar}>
        <div>
          <div className="page-eyebrow">MANAGEMENT</div><h1 className="page-title">Customers</h1>
        </div>
        <div style={s.badge}>{customers.length} customers</div>
      </div>

      {/* Add form */}
      <div style={s.formCard}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
          <div style={s.formTitle}>ADD NEW CUSTOMER</div>
          <button className="gen-btn" onClick={handleGenerate}
            style={{background:'var(--border)',border:'1px solid rgba(15,23,42,0.10)',borderRadius:7,padding:'6px 14px',fontSize:12,color:'var(--text-secondary)',cursor:'pointer',transition:'all 0.18s'}}>
            🎲 Generate code & password
          </button>
        </div>
        <form onSubmit={handleAdd} style={{display:'flex',gap:12,alignItems:'flex-end',flexWrap:'wrap'}}>
          <div style={s.field}>
            <label style={s.label}>CUSTOMER CODE</label>
            <input className="ci" style={{...s.input,fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:700,color:'var(--accent)'}}
              value={form.code} onChange={e=>setForm(f=>({...f,code:e.target.value.toUpperCase()}))} placeholder="ABCD" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>CUSTOMER NAME</label>
            <input className="ci" style={s.input} value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} placeholder="John Doe" required />
          </div>
          <div style={s.field}>
            <label style={s.label}>PASSWORD</label>
            <div style={{position:'relative'}}>
              <input className="ci" style={{...s.input,paddingRight:36}}
                type={showPass?'text':'password'}
                value={form.password} onChange={e=>setForm(f=>({...f,password:e.target.value}))}
                placeholder="Enter password" required />
              <button type="button" onClick={()=>setShowPass(s=>!s)}
                style={{position:'absolute',right:8,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',color:'var(--text-muted)',cursor:'pointer',fontSize:14}}>
                {showPass?'🙈':'👁'}
              </button>
            </div>
          </div>
          {error && <div style={s.error}>{error}</div>}
          <button className="add-btn" style={s.addBtn} type="submit" disabled={loading}>{loading ? 'Adding...' : '+ Add customer'}</button>
        </form>
      </div>

      <div style={{display:'flex',gap:20}}>
        {/* Customer list */}
        <div style={{flex:1}}>
          <div style={s.tableWrap}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead><tr>{['Code','Name','Created','',''].map((h,i)=><th key={i} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {customers.length === 0 ? (
                  <tr><td colSpan={5} style={{padding:'40px',textAlign:'center',color:'var(--text-muted)',fontSize:13}}>No customers yet</td></tr>
                ) : customers.map(c=>(
                  <tr key={c.id} className={`cust-row${selected?.id===c.id?' active':''}`} onClick={()=>openCustomer(c)}>
                    <td style={s.td}><span style={s.codeBadge}>{c.code}</span></td>
                    <td style={s.td}>{c.name}</td>
                    <td style={{...s.td,color:'var(--text-muted)',fontSize:12}}>{new Date(c.created_at).toLocaleDateString('vi-VN')}</td>
                    <td style={s.td} onClick={e=>e.stopPropagation()}>
                      <button className="pass-btn" onClick={()=>{setPassModal(c);setNewPass('');}}>🔑 Set password</button>
                    </td>
                    <td style={s.td} onClick={e=>e.stopPropagation()}>
                      <button className="del-btn" onClick={()=>handleDelete(c.id)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Panel alias */}
        {selected && (
          <div style={{width:320,flexShrink:0}}>
            <div style={{...s.formCard,marginBottom:0}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14}}>
                <div>
                  <div style={s.formTitle}>ALIASES OF</div>
                  <div style={{fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:700,fontSize:15,color:'var(--accent)'}}>{selected.code}</div>
                </div>
                <button onClick={()=>setSelected(null)} style={{background:'none',border:'none',color:'var(--text-muted)',cursor:'pointer',fontSize:18}}>×</button>
              </div>
              <form onSubmit={handleAddAlias} style={{display:'flex',gap:8,marginBottom:14}}>
                <input className="ci" style={{...s.input,flex:1}} value={newAlias} onChange={e=>setNewAlias(e.target.value)} placeholder="Name on label..." required />
                <button className="add-btn" style={{...s.addBtn,padding:'8px 12px',whiteSpace:'nowrap'}} type="submit">+ Add</button>
              </form>
              <div style={{minHeight:60}}>
                {aliases.length === 0 ? (
                  <div style={{fontSize:12,color:'var(--text-muted)',textAlign:'center',padding:'16px 0'}}>No aliases yet</div>
                ) : aliases.map(a=>(
                  <div key={a.id} className="alias-tag">
                    <span>{a.name_on_label}</span>
                    <button className="alias-del" onClick={()=>handleDeleteAlias(a.id)}>×</button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Password modal */}
      {passModal && (
        <div className="modal-overlay" onClick={()=>setPassModal(null)}>
          <div style={{background:'var(--bg-secondary)',border:'1px solid rgba(15,23,42,0.10)',borderRadius:12,padding:24,width:380}} onClick={e=>e.stopPropagation()}>
            <div style={{fontSize:14,fontWeight:700,color:'var(--text-primary)',marginBottom:4}}>Set password</div>
            <div style={{fontSize:13,color:'var(--text-muted)',marginBottom:20}}>
              Customer <span style={{color:'var(--accent)',fontVariantNumeric:"tabular-nums",fontWeight:600,fontWeight:700}}>{passModal.code}</span> — {passModal.name}
            </div>
            <div style={{display:'flex',gap:8,marginBottom:16}}>
              <input
                style={{flex:1,background:'var(--bg-tertiary)',border:'1px solid rgba(15,23,42,0.08)',borderRadius:8,padding:'9px 12px',fontSize:13,color:'var(--text-primary)',outline:'none',}}
                value={newPass} onChange={e=>setNewPass(e.target.value)} placeholder="Enter new password..."
                onFocus={e=>{e.target.style.borderColor='var(--accent)';e.target.style.boxShadow='0 0 0 3px var(--accent-bg)';}}
                onBlur={e=>{e.target.style.borderColor='var(--border-strong)';e.target.style.boxShadow='none';}}
              />
              <button onClick={()=>setNewPass(genPass())}
                style={{background:'var(--border)',border:'1px solid rgba(15,23,42,0.10)',borderRadius:8,padding:'9px 12px',fontSize:12,color:'var(--text-secondary)',cursor:'pointer',whiteSpace:'nowrap'}}>
                🎲 Random
              </button>
            </div>
            <div style={{display:'flex',gap:8}}>
              <button onClick={handleSetPass} disabled={!newPass.trim()||passLoading}
                style={{flex:1,background:'var(--bg-tertiary)',color:'var(--text-primary)',border:'1px solid var(--accent-strong)',borderRadius:8,padding:'10px',fontSize:13,fontWeight:700,cursor:'pointer',opacity:!newPass.trim()?0.4:1}}>
                {passLoading ? 'Saving...' : '✓ Save password'}
              </button>
              <button onClick={()=>setPassModal(null)}
                style={{flex:1,background:'var(--border)',color:'var(--text-secondary)',border:'1px solid rgba(15,23,42,0.08)',borderRadius:8,padding:'10px',fontSize:13,cursor:'pointer'}}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  topbar: { display:'flex', alignItems:'flex-start', justifyContent:'space-between', marginBottom:22 },
  pageLabel: { fontSize:10, fontWeight:700, color:'var(--text-muted)', letterSpacing:2, textTransform:'uppercase', marginBottom:4 },
  pageTitle: { fontSize:22, fontWeight:600, color:'var(--text-primary)', letterSpacing:-0.3 },
  badge: { background:'var(--border)', border:'1px solid rgba(15,23,42,0.08)', borderRadius:20, padding:'5px 12px', fontSize:12, color:'var(--text-secondary)', marginTop:6 },
  formCard: { background:'var(--bg-tertiary)', border:'1px solid rgba(15,23,42,0.07)', borderRadius:12, padding:'18px 20px', marginBottom:20 },
  formTitle: { fontSize:10, fontWeight:700, color:'var(--text-muted)', letterSpacing:1.8 },
  field: { display:'flex', flexDirection:'column', gap:6 },
  label: { fontSize:10, fontWeight:700, color:'var(--text-muted)', letterSpacing:1, textTransform:'uppercase' },
  input: { background:'var(--bg-tertiary)', border:'1px solid rgba(15,23,42,0.08)', borderRadius:8, padding:'9px 12px', fontSize:13, color:'var(--text-primary)', transition:'all 0.18s',  },
  error: { background:'rgba(220,38,38,0.08)', color:'#b91c1c', borderLeft:'2px solid #ff5252', padding:'8px 12px', borderRadius:6, fontSize:12 },
  addBtn: { background:'var(--bg-tertiary)', color:'var(--text-primary)', border:'1px solid var(--accent-strong)', borderRadius:8, padding:'9px 20px', fontSize:13, fontWeight:700, cursor:'pointer', transition:'all 0.18s',  },
  tableWrap: { background:'var(--bg-tertiary)', border:'1px solid rgba(15,23,42,0.07)', borderRadius:12, overflow:'hidden' },
  th: { background:'var(--bg-tertiary)', padding:'10px 14px', fontSize:10, fontWeight:700, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:1, textAlign:'left', borderBottom:'1px solid rgba(15,23,42,0.07)' },
  td: { padding:'11px 14px', fontSize:13, color:'var(--text-primary)' },
  codeBadge: { fontVariantNumeric:"tabular-nums",fontWeight:600, fontWeight:700, fontSize:13, color:'var(--accent)', background:'var(--accent-bg)', border:'1px solid rgba(22,163,74,0.22)', padding:'3px 9px', borderRadius:6 },
};
